/**
 * File jquery.theme.js.
 *
 * Handles the primary JavaScript functions for the theme.
 */
var win = {};

jQuery(function ($) {

    // Element viewport visibility.
    $.fn.dayaIsVisible = function () {
        var rect = this[0].getBoundingClientRect();
        return (
            rect.bottom >= 0 &&
            rect.right >= 0 &&
            rect.top <= (window.innerHeight || document.documentElement.clientHeight) &&
            rect.left <= (window.innerWidth || document.documentElement.clientWidth)
        );
    };

    onResize();
    $(window).bind('resize', onResize);

    function onResize() {
        win.w = $(window).width();
        win.h = $(window).height();
        if (win.w <= 750) {
            initGallery();
            initMovieTop();
        }
    }


    function initVideo() {
        var ua = navigator.userAgent.toLocaleLowerCase()
        // x5内核
        var isWeixin = ua.match(/micromessenger/) != null || ua.match(/tencenttraveler/) != null || ua.match(/qqbrowse/) != null

        // if (ua.match(/micromessenger/) != null ||ua.match(/tencenttraveler/) != null || ua.match(/qqbrowse/) != null) {
        //     document.querySelector('video').setAttribute('x-webkit-airplay', true);
        //     document.querySelector('video').setAttribute('x5-playsinline', true);
        //     document.querySelector('video').setAttribute('webkit-playsinline', true);
        //     document.querySelector('video').setAttribute('playsinline', true);
        //     // x5内核 启用同层H5播放器（会有黑屏缓冲问题）
        //     document.querySelector('video').setAttribute('x5-video-player-type', 'h5');
        //     document.querySelector('video').setAttribute('x5-video-player-fullscreen', false);
        //     document.querySelector('video').setAttribute('x5-video-ignore-metadata', true);
        // } else {
        //     // ios端
        //     document.querySelector('video').setAttribute('webkit-playsinline', true);
        //     document.querySelector('video').setAttribute('playsinline', true);
        // }

        $('.wp-block-video > video').each(function (i, e) {
            //if (isWeixin) {
                $(this).attr('x-webkit-airplay', true);
                $(this).attr('x5-playsinline', true);
                // x5内核 启用同层H5播放器（会有黑屏缓冲问题）
                $(this).attr('x5-video-player-type', 'h5');
                $(this).attr('x5-video-player-fullscreen', false);
                $(this).attr('x5-video-ignore-metadata', true);
            //}
            $(this).attr('webkit-playsinline', true);
            $(this).attr('playsinline', true);
            $(this).attr('controls', null);
            //$(this).attr('preload', 'auto');
            $(this).attr('controlsList', 'nofullscreen nodownload');


            $(this).after('<div class="video-play-btn"></div>')

            this.addEventListener('pause', function (e) { //暂停开始执行的函数
                e.preventDefault();
                $(this).next().removeClass("playing");
                $(this).attr('controls', null);
                console.log("暂停播放");
            });
            this.addEventListener('playing', function (e) { //暂停开始执行的函数
                e.preventDefault();
                $(this).next().addClass("playing");
                $(this).attr('controls', 'controls');
                console.log("开始播放");
            });
            this.addEventListener('ended', function (e) { //暂停开始执行的函数
                e.preventDefault();
                $(this).next().removeClass("playing");
                $(this).attr('controls', null);
                console.log("视频结束");
            });
        });

        $(".video-play-btn").on("click", function (e) {
            e.preventDefault();
            var $curVideo = $(this).prev();
            if ($curVideo[0].paused) {
                $("video").each(function (index, element) {
                    var $element = $(element);
                    if ($(this) != $curVideo && !this.paused) {
                        this.pause();
                        //$(this).next().removeClass("playing");
                    }
                });
                // console.log($curVideo[0]);
                $curVideo[0].play();
            } else {
                $curVideo[0].pause();
            }
        });
        console.log("initVideo");
    }

    initVideo();

    var initGalleryed = false;

    function initGallery() {
        if (initGalleryed) return;
        initGalleryed = true;
        $('.gallery').find("img[data-src]").each(function (i, e) {
            $(this).attr("src", $(this).attr("data-src")).removeAttr("data-src");
        });
        $('.gallery').bxSlider({
            "slideSelector": ".gallery-item",
            "controls": false,
            "infiniteLoop": false,
            "speed": 800,
            easing: "easeInOutQuart"
        });

        $('.gallerys .blocks-gallery-grid').find("img[data-src]").each(function (i, e) {
            $(this).attr("src", $(this).attr("data-src")).removeAttr("data-src");
        });
        $('.gallerys .blocks-gallery-grid').bxSlider({
            "slideSelector": ".blocks-gallery-item",
            "controls": false,
            "infiniteLoop": false,
            "speed": 800,
            easing: "easeInOutQuart"
        });
    }

    $('.daya-slider').find("img").each(function (i, e) {
        $(this).attr("src", $(this).attr("data-src")).removeAttr("data-src");
    });

    var dayaSlider = $('.bxslider').bxSlider({
        // slideWidth: 1000,
        speed: 1200,
        slideMargin: 0,
        // 'mode': 'fade',
        controls: true,
        infiniteLoop: false,
        easing: "easeInOutQuart",
        hideControlOnEnd: true,
        // easing: "cubic-bezier(0.65, 0.05, 0.36, 1)",
        // 'prevText': '<i class="fa fa-angle-left"></i>',
        // 'nextText': '<i class="fa fa-angle-right"></i>',
        onSliderLoad: function (currentIndex) {
            console.log('onSliderLoad!');
            $('.bxslider').find(".item-img").each(function (i, e) {
                if (i > 0) {
                    $(this).css({opacity: 0});
                    $(this).find(".item-info").hide();
                }
            });
        },
        onSlideAfter: function ($slideElement) {
            console.log('onSlideAfter!');

            $slideElement.siblings('li').find(".item-info").hide();
            $slideElement.find(".item-info").show();

        },
        //  onSlideNext: changeSlide,
        onSlideBefore: changeSlide
    });

    function changeSlide($slideElement, oldIndex, newIndex) {
        // console.log("changeSlide", $slideElement, oldIndex, newIndex);
        $slideElement.siblings('li').find(".item-img").animate({opacity: 0}, 1000);
        $slideElement.find(".item-img").animate({opacity: 1}, 1000);

        // if (oldIndex < newIndex) {
        //     $slideElement.parents('.bxslider').find(".item-img").removeClass("slideInRight").removeClass("slideInLeft").addClass("slideOutLeft");
        //     $slideElement.find(".item-img").removeClass("slideOutLeft").removeClass("slideOutRight").addClass("slideInRight");
        //     // $slideElement.find("span").addClass("anim-right");
        // } else {
        //     $slideElement.parents('.bxslider').find(".item-img").removeClass("slideInRight").removeClass("slideInLeft").addClass("slideOutRight");
        //     $slideElement.find(".item-img").removeClass("slideOutLeft").removeClass("slideOutRight").addClass("slideInLeft");
        //     // $slideElement.find("span").addClass("anim-left");
        // }
    }

    $("img[data-src]").addClass("fadeInImg").lazyload({data_attribute: "src", effect: "fadeIn"});

    // Burst animation.
    var mousePos = {x: 0, y: 0};
    $(document).mousemove(function (e) {
        mousePos = {
            x: e.pageX,
            y: e.pageY
        };
    });

    $.fn.dayaBurstAnimation = function (options) {
        var settings = $.extend({event: "click", container: "parent"}, options);

        return $(this).each(function () {
            var $$ = $(this),
                $p = settings.container === 'parent' ? $$.parent() : $$.closest(settings.container),
                $o = $('<div class="burst-animation-overlay"></div>'),
                $c = $('<div class="burst-circle"></div>').appendTo($o);

            $$.on(settings.event, function () {
                $o.appendTo($p);
                $c
                    .css({
                        top: mousePos.y - $p.offset().top,
                        left: mousePos.x - $p.offset().left,
                        opacity: 0.1,
                        scale: 1
                    })
                    .transition({
                        opacity: 0,
                        scale: $p.width()
                    }, 500, 'ease', function () {
                        $o.detach();
                    });
            });

        });
    };

    // Setup FitVids for entry content, Page Builder by SiteOrigin and WooCommerce. Ignore Tableau.
    /*
    if (typeof $.fn.fitVids !== 'undefined') {
        $('.entry-content, .entry-content .panel, .woocommerce #main').fitVids({ignore: '.tableauViz'});
    }
    */

    // FlexSlider.
    /*
    $(window).on('load', function () {
        $('.flexslider').each(function () {
            $(this).flexslider({
                animation: 'slide',
                controlNav: false,
                customDirectionNav: $(this).find('.flex-direction-nav a')
            });
        });
    });*/

    // Scroll to top.
    var sttWindowScroll = function () {
        var top = window.pageYOffset || document.documentElement.scrollTop;
        if (top > $('#masthead').outerHeight()) {
            if (!$('#scroll-to-top').hasClass('show')) {
                $('#scroll-to-top').css('pointer-events', 'auto').addClass('show');
            }
        } else {
            if ($('#scroll-to-top').hasClass('show')) {
                $('#scroll-to-top').css('pointer-events', 'none').removeClass('show');
            }
        }
    };
    sttWindowScroll();
    $(window).scroll(sttWindowScroll);

    $('#scroll-to-top').click(function () {
        $('html, body').animate({scrollTop: 0});
    });

    // Sticky header.
    if ($('#masthead').hasClass('sticky')) {
        var $mhs = false,
            pageTop = $('#page').offset().top,
            $mh = $('#masthead'),
            $tb = $('#topbar'),
            $tbwc = $('#topbar .woocommerce-store-notice[style*="display: none"]');

        var smSetup = function () {

            // if ($('body').hasClass('mobile-header-ns') && ($(window).width() < daya_resp_menu_params.collapse)) return;

            // if ( $mhs === false ) {
            // 	$mhs = $( '<div class="masthead-sentinel"></div>' ).insertAfter( $mh );
            // 	$mhs.css( 'height', $mh.outerHeight() );
            // }

            // if (!$('body').hasClass('no-topbar') && !$tb.dayaIsVisible()) {
            //     $('body').addClass('topbar-out');
            // }
            //
            // if ($tb.length && $('body').hasClass('topbar-out') && $tb.dayaIsVisible()) {
            //     $('body').removeClass('topbar-out');
            // }
            //
            // if ($('body').hasClass('no-topbar') && !$(window).scrollTop()) {
            //     $('body').addClass('topbar-out');
            // }

            // if ($('body').hasClass('no-topbar') || ( !$('body').hasClass('no-topbar') && $('body').hasClass('topbar-out') ) || $tbwc.length) {
            //     $mh.css('position', 'fixed');
            // } else if (!$('body').hasClass('no-topbar') && !$('body').hasClass('topbar-out')) {
            //     $mh.css('position', 'absolute');
            // }

        };
        // smSetup();
        // $(window).resize(smSetup).scroll(smSetup);

        // Sticky header shadow.
        var smShadow = function () {
            if ($(window).scrollTop() > 0) {
                $($mh).addClass('stuck');
            } else {
                $($mh).removeClass('stuck');
            }
        };
        smShadow();
        $(window).scroll(smShadow);

        /*
        // Header padding to be used if logo scaling is enabled.
        var mhPadding = {
            top: parseInt($mh.css('padding-top')),
            bottom: parseInt($mh.css('padding-bottom'))
        };

        // Sticky header logo scaling.
        if ($mh.data('scale-logo')) {
            var smResizeLogo = function () {
                var top = window.pageYOffset || document.documentElement.scrollTop;
                top -= pageTop;

                var $img = $mh.find('.site-branding img'),
                    $branding = $mh.find('.site-branding > *');

                $img.removeAttr('style');
                var imgWidth = $img.width(),
                    imgHeight = $img.height();

                if (top > 0) {
                    var scale = 0.775 + ( Math.max(0, 48 - top) / 48 * ( 1 - 0.775 ) );

                    if ($img.length) {

                        $img.css({
                            width: imgWidth * scale,
                            height: imgHeight * scale,
                            'max-width': 'none'
                        });
                    } else {
                        $branding.css('transform', 'scale(' + scale + ')');
                    }

                    $mh.css({
                        'padding-top': mhPadding.top * scale,
                        'padding-bottom': mhPadding.bottom * scale
                    }).addClass('stuck');
                } else {
                    if (!$img.length) {
                        $branding.css('transform', 'scale(1)');
                    }

                    $mh.css({
                        'padding-top': mhPadding.top,
                        'padding-bottom': mhPadding.bottom
                    }).removeClass('stuck');
                }
            };
            smResizeLogo();
            $(window).scroll(smResizeLogo).resize(smResizeLogo);
        }*/
    }

    // Header search.
    $('.search-field').dayaBurstAnimation({event: "focus", container: ".search-form"});

    var $hs = $('#header-search');
    $('#masthead .search-icon').click(function () {
        $hs.fadeIn('fast');
        $hs.find('form').css('margin-top', -$hs.find('form').innerHeight() / 2);
        $hs.find('input[type="search"]').focus().select();
        $hs.find('#close-search').addClass('animate-in');
    });
    $hs.find('#close-search').click(function () {
        $hs.fadeOut(350);
        $(this).removeClass('animate-in');
    });
    $(window).scroll(function () {
        if ($hs.is(':visible')) {
            $hs.find('form').css('margin-top', -$hs.find('form').outerHeight() / 2);
        }
    });

    // Close the header search with the escape key.
    $(document).keyup(function (e) {
        if (e.keyCode == 27) { // Escape key maps to keycode 27.
            $('#close-search.animate-in').trigger('click');
        }
    });

    // Main menu.
    // Remove the no-js body class.
    $('body.no-js').removeClass('no-js');
    if ($('body').hasClass('css3-animations')) {
        // Display the burst animation.
        $('.search-field').dayaBurstAnimation({event: "focus", container: ".search-form"});

        var dayaResetMenu = function () {
            $('.main-navigation ul ul').each(function () {
                var $$ = $(this);
                var width = Math.max.apply(Math, $$.find('> li:not(.mini_cart_item) > a').map(function () {
                    return $(this).width();
                }).get());
                $$.find('> li > a').width(width);
            });
        };
        dayaResetMenu();
        $(window).resize(dayaResetMenu);

        // Add keyboard access to the menu.
        $('.menu-item').children('a').focus(function () {
            $(this).parents('ul, li').addClass('focus');
        });

        // Click event fires after focus event.
        $('.menu-item').children('a').click(function () {
            $(this).parents('ul, li').removeClass('focus');
        });

        $('.menu-item').children('a').focusout(function () {
            $(this).parents('ul, li').removeClass('focus');
        });

        // Burst animation when the user clicks on a sub link.
        // $('.main-navigation ul ul li a').dayaBurstAnimation({event: "click", container: "parent"});
    }

    // Main menu current menu item indication.
    jQuery(document).ready(function ($) {
        if (window.location.hash) {
            return;
        } else {
            $('#site-navigation a[href="' + window.location.href + '"]').parent('li').addClass('current-menu-item');
        }
        $(window).scroll(function () {
            if ($('#site-navigation ul li').hasClass('current')) {
                $('#site-navigation li').removeClass('current-menu-item');
            }
        });
    });

    // Smooth scroll from internal page anchors.
    var adminBarHeight = $('#wpadminbar').outerHeight(),
        isAdminBar = $('body').hasClass('admin-bar'),
        isStickyHeader = $('header').hasClass('sticky');

    // Header height. 2px to account for header shadow.
    if (isStickyHeader && isAdminBar && jQuery(window).width() > 600) { // From 600px the admin bar isn't sticky so we shouldn't take its height into account.
        var headerHeight = adminBarHeight + $('header').outerHeight() - 2;
    } else if (isStickyHeader) {
        var headerHeight = $('header').outerHeight() - 2;
    } else {
        var headerHeight = 0;
    }

    $.fn.dayaSmoothScroll = function () {
        $(this).click(function (e) {

            var hash = this.hash;
            var idName = hash.substring(1);	// Get ID name.
            var alink = this;                 // This button pressed.

            // Check if there is a section that had same id as the button pressed.
            if (jQuery('.panel-grid [id*=' + idName + ']').length > 0) {
                jQuery('#site-navigation .current').removeClass('current');
                jQuery(alink).parent('li').addClass('current');
            } else {
                jQuery('#site-navigation .current').removeClass('current');
            }
            if (location.pathname.replace(/^\//, '') == this.pathname.replace(/^\//, '') && location.hostname == this.hostname) {
                var target = jQuery(this.hash);
                target = target.length ? target : jQuery('[name=' + this.hash.slice(1) + ']');
                if (target.length) {
                    jQuery('html, body').animate({
                        scrollTop: target.offset().top - headerHeight
                    }, 1200);
                    return false;
                }
            }
        });
    };

    jQuery(window).load(function () {
        $('#site-navigation a[href*="#"]:not([href="#"]), .comments-link a[href*="#"]:not([href="#"]), .puro-scroll[href*="#"]:not([href="#"])').dayaSmoothScroll();
    });

    // Smooth scroll from external anchors.
    jQuery(window).load(function () {

        if (location.pathname.replace(/^\//, '') == window.location.pathname.replace(/^\//, '') && location.hostname == window.location.hostname) {
            var target = jQuery(window.location.hash);
            if (target.length) {
                $(document).scrollTop(0); // The late loading of certain SiteOrigin widgets, unfortunately, makes this necessary. If a better method is known, please, submit a PR or reach out.
                jQuery('html, body').animate({
                    scrollTop: target.offset().top - headerHeight
                }, 1200);
                return false;
            }
        }
    });

    // Indicate which section of the page we're viewing with selected menu classes.
    function dayaSelected() {

        // Cursor position.
        var scrollTop = jQuery(window).scrollTop();

        // Used for checking if the cursor is in one section or not.
        var isInOneSection = 'no';

        // For all sections check if the cursor is inside a section.
        jQuery('.panel-row-style').each(function () {

            // Section ID.
            var thisID = '#' + jQuery(this).attr('id');

            // Distance between top and our section. Minus 2px to compensate for an extra pixel produced when a Page Builder row bottom margin is set to 0.
            var offset = jQuery(this).offset().top - 2;

            // Section height.
            var thisHeight = jQuery(this).outerHeight();

            // Where the section begins.
            var thisBegin = offset - headerHeight;

            // Where the section ends.
            var thisEnd = offset + thisHeight - headerHeight;

            // If position of the cursor is inside of the this section.
            if (scrollTop >= thisBegin && scrollTop <= thisEnd) {
                isInOneSection = 'yes';
                jQuery('#site-navigation .current').removeClass('current');
                // Find the menu button with the same ID section.
                jQuery('#site-navigation a[href$="' + thisID + '"]').parent('li').addClass('current');	// Find the menu button with the same ID section.
                return false;
            }
            if (isInOneSection === 'no') {
                jQuery('#site-navigation .current').removeClass('current');
            }
        });
    }

    jQuery(window).on('scroll', dayaSelected);

    // Mobile menu.
    var $mobileMenu = false;
    $('#mobile-menu-button').click(function (e) {
        e.preventDefault();
        var $$ = $(this);
        $$.toggleClass('to-close');

        if ($mobileMenu === false) {
            $mobileMenu = $('<div></div>')
                .append($('.main-navigation ul').first().clone())
                .attr('id', 'mobile-navigation')
                .appendTo('#masthead').hide();

            if ($('#header-search form').length) {
                $mobileMenu.append($('#header-search form').clone());
            }

            if ($('.main-navigation .shopping-cart').length) {
                $mobileMenu.append($('.main-navigation .shopping-cart .shopping-cart-link').clone());
            }

            $mobileMenu.find('#primary-menu').show().css('opacity', 1);
            $mobileMenu.find('.menu-item-has-children > a, .page_item_has_children > a').after('<button class="dropdown-toggle" aria-expanded="false"><i class="icon-chevron-down" aria-hidden="true"></i></button>');
            $mobileMenu.find('.dropdown-toggle').click(function (e) {
                e.preventDefault();
                $(this).toggleClass('toggle-open').next('.children, .sub-menu').slideToggle('fast');
            });

            var mmOverflow = function () {
                if ($('#masthead').hasClass('sticky')) {
                    var adminBarHeight = $('#wpadminbar').css('position') === 'fixed' ? $('#wpadminbar').outerHeight() : 0;
                    var mhHeight = $('#masthead').innerHeight();
                    var mobileMenuHeight = $(window).height() - mhHeight - adminBarHeight;
                    $('#mobile-navigation').css('max-height', mobileMenuHeight);
                }
            };
            mmOverflow();

            $(window).resize(mmOverflow);
            $('#mobile-navigation').scroll(mmOverflow);

        }

        $mobileMenu.slideToggle();

        $('#mobile-navigation a').click(function (e) {
            if ($mobileMenu.is(' :visible')) {
                $mobileMenu.slideUp('fast');
            }

            $$.removeClass('to-close');
        });

        $('#mobile-navigation a[href*="#"]:not([href="#"])').dayaSmoothScroll();

    });


    // $('.video-play-button').magnificPopup({
    //     items: {
    //         src: $('<div class="video-popup">Dynamically created popup</div>'),
    //         type: 'inline'
    //     }
    // });
    $('.video-play-button').on("click", function (e) {
        // console.log($(this).data("poster"), $(this).data("video"));
        var curPopup = $.magnificPopup.open({
            items: {
                // src: $('<div class="video-popup"><video src="' + $(this).data("video") + '" poster="' + $(this).data("poster") + '" width="960" preload autoplay id="videoPlayer"></video></div>'),
                src: $('<div class="video-popup"><video src="' + $(this).data("video") + '" width="960" preload autoplay id="videoPlayer"></video></div>'),
                type: 'inline'
            },
            mainClass: 'mfp-fade',
            midClick: true,
            closeBtnInside: false,
            closeOnBgClick: false,
            callbacks: {
                open: function () {
                    //console.log("alertBox open");
                    var mvPlayer = new MediaElementPlayer('#videoPlayer', {
                        enablePluginDebug: false,
                        plugins: ['flash'],
                        type: '',
                        // pluginPath: 'js/mediae/',
                        // flashName: 'flashmediaelement.swf',
                        defaultVideoWidth: 960,
                        defaultVideoHeight: 540,
                        pluginWidth: 0,
                        pluginHeight: 0,
                        timerRate: 250,
                        startVolume: 1,
                        // features: ['playpause', 'progress', 'current', 'duration', 'tracks', 'volume', 'fullscreen'],
                        features: ['playpause', 'progress', 'current', 'duration'],
                        // features: [],
                        success: function (mediaElement, domObject) {
                            mediaElement.addEventListener('play', function (e) {

                            }, false);
                            mediaElement.addEventListener('pause', function (e) {
                            }, false);
                            mediaElement.addEventListener('ended', function (e) {
                                console.log('ended');
                                // $(".home-video-player").hide();
                                //mvPlayer.exitFullScreen();
                                // curPopup.close();
                                $.magnificPopup.close();
                            }, false);
                        },
                        error: function () {
                        }
                    });
                },
                close: function () {
                    console.log("alertBox close");
                },
                afterClose: function () {
                    console.log('Popup is completely closed');

                    // $('video, audio').mediaelementplayer({ shimScriptAccess: 'always' });
                    // if ($aUrl != undefined && $aUrl != "") {
                    //     if ($target != undefined) {
                    //         window.open($aUrl, $target);
                    //     } else {
                    //         location.href = $aUrl;
                    //     }
                    // }
                    // if (typeof($callback) == "function") {
                    //     $callback();
                    // }
                }
            }
        });
    });

    if ($(".sub-menu .sub-list").length > 0) {
        $(".sub-menu .sub-list").width($(".sub-menu .sub-list > ul").width() + 50);

        var scrollStartX = 0;
        if ($.cookie("SubListX") != undefined && $.cookie("SubListX") != null && $.cookie("SubListX") != "null") {
            scrollStartX = parseInt($.cookie("SubListX"));
        }
        var subScroll = new IScroll('.page-title-section > .sub-menu> .container', {
            scrollbars: false,
            scrollX: true,
            scrollY: false,
            startX: scrollStartX,
            click: true, tap: true,
            mouseWheel: true
        });

        $(".sub-menu .sub-list ul li a").on("click", function (e) {
            $.cookie("SubListX", subScroll.x, {expires: 2});
        })
    }

    if ($(".sub-menu2 .sub-list").length > 0) {
        $(".sub-menu2 .sub-list").width($(".sub-menu2 .sub-list > ul").width() + 50);

        var scrollStartX2 = 0;
        if ($.cookie("SubListX2") != undefined && $.cookie("SubListX2") != null && $.cookie("SubListX2") != "null") {
            scrollStartX2 = parseInt($.cookie("SubListX2"));
        }
        var subScroll2 = new IScroll('.page-title-section > .sub-menu2 > .container', {
            scrollbars: false,
            scrollX: true,
            scrollY: false,
            startX: scrollStartX2,
            click: true, tap: true,
            mouseWheel: true
        });

        $(".sub-menu2 .sub-list ul li a").on("click", function (e) {
            $.cookie("SubListX2", subScroll2.x, {expires: 2});
        })
    }

    // subScroll.refresh();

    function initMovieTop() {
        if (typeof mejs != "undefined") {
            $('.video-top')
                .not('.mejs-container')
                .filter(function () {
                    return !$(this).parent().hasClass('mejs-mediaelement');
                })
                .mediaelementplayer({
                    enablePluginDebug: false,
                    alwaysShowControls: true,
                    hideVideoControlsOnLoad: false,
                    // plugins: ['flash'],
                    type: '',
                    // defaultVideoWidth: 640,
                    pluginWidth: 0,
                    pluginHeight: 0,
                    timerRate: 250,
                    startVolume: 1,
                    // features: ['playpause', 'progress', 'current', 'duration', 'tracks', 'volume', 'fullscreen'],
                    // features: ['playpause', 'progress', 'current', 'duration'],
                    // features: [],
                    success: function (mediaElement, domObject) {
                        mediaElement.addEventListener('play', function (e) {
                        }, false);
                        mediaElement.addEventListener('pause', function (e) {
                        }, false);
                        mediaElement.addEventListener('ended', function (e) {
                            console.log('ended');
                        }, false);
                    },
                    error: function () {
                    }
                });
        }
    }
});
